export const capitalizeFirstChar = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
